/* eslint-disable @typescript-eslint/no-empty-function */

/**
 * Returns a void function for use as a CONSTANT
 */
function noop() {}
export default noop
